import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contrastColor'
})
export class ContrastColorPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (!value) return '#000';
    const rgb = value.replace('#', '').match(/.{2}/g);
    if (!rgb || rgb.length !== 3) return '#000';
    const values = rgb.map(x => parseInt(x, 16));
    const brightness = Math.round((values[0] * 299 + values[1] * 587 + values[2] * 114) / 1000)
    if(brightness < 150){
      return '#fff';
    } else {
      return '#000';
    }
  }

}
